export enum MessageType {
  POSITIVE,
  NEGATIVE,
  WARNING,
  INFO,
}
